module.exports = __webpack_public_path__ + "img/violet_070.0088f8d9.png";